//@ts-nocheck

export const getLatestSelectedKeyframeIndices = (prop: { selectedKeys: any; }) => {
    let selectedIndices = prop.selectedKeys; 
    selectedIndices = selectedIndices.sort((a: number, b: number) => a - b);

    return selectedIndices.slice(selectedIndices.length - 2, selectedIndices.length);
}
export const clearSpatialOutEaseOnKeyframe = (prop, keyIndex) => {
  if(prop.propertyValueType  == PropertyValueType.ThreeD_SPATIAL) {
    let existingSpatialEaseIn = prop.keyInSpatialTangent(keyIndex)
    !existingSpatialEaseIn ? existingSpatialEaseIn = [0, 0, 0] : null
    prop.setSpatialTangentsAtKey(keyIndex, existingSpatialEaseIn, [0, 0, 0])
  } else if (prop.propertyValueType  == PropertyValueType.TwoD_SPATIAL) {
    let existingSpatialEaseIn = prop.keyInSpatialTangent(keyIndex)
    !existingSpatialEaseIn ? existingSpatialEaseIn = [0, 0] : null
    prop.setSpatialTangentsAtKey(keyIndex, existingSpatialEaseIn, [0, 0])
  }
}

export const clearAllSpatialEaseOnKeyframe = (prop, keyIndex) => {
  if(prop.propertyValueType  == PropertyValueType.ThreeD_SPATIAL) {
    prop.setSpatialTangentsAtKey(keyIndex, [0, 0, 0] , [0, 0, 0])
  } else if (prop.propertyValueType  == PropertyValueType.TwoD_SPATIAL) {
    prop.setSpatialTangentsAtKey(keyIndex, [0, 0] , [0, 0])
  }
}

export const getNearestFrameTime = (comp, newKeyframeTime) => {
  const compStartTime = comp.displayStartTime;
  const frameDuration = comp.frameDuration;
  const elapsedTime = newKeyframeTime - compStartTime;
  const nearestFrameIndex = Math.round(elapsedTime / frameDuration);
  const nearestFrameTime = nearestFrameIndex * frameDuration + compStartTime;
  return nearestFrameTime;
}



export const createBounceKeyframe = (req) => {
  
  let { prop, newKeyframes } = req;
  
  for (let i = 0; i < newKeyframes.length; i++) {
    let { time, value, index, hang, alternate } = newKeyframes[i];
    prop.addKey(time);

    if (value instanceof Array) {
      value[2] = 0; //TODO: Handle 3D data
    }

    prop.setValueAtKey(index, value)
    if (alternate) {
      var easeIn = new KeyframeEase(0, hang); //set this 0 to 100.... for the hang var
      var easeOut = new KeyframeEase(0, hang);
      if (prop.matchName.includes('Scale')) {
        prop.setTemporalEaseAtKey(index, [easeIn, easeIn, easeIn], [easeOut, easeOut, easeOut]);
      } else {
        prop.setTemporalEaseAtKey(index, [easeIn], [easeOut]);
      }
      prop.setInterpolationTypeAtKey(index, KeyframeInterpolationType.BEZIER, KeyframeInterpolationType.BEZIER)
    } else {
      prop.setInterpolationTypeAtKey(index, KeyframeInterpolationType.LINEAR, KeyframeInterpolationType.LINEAR)
    }

  }
}

export const getKeyValues = (prop, keyToCopy) => {
  const keyInInterpolationType = prop.keyInInterpolationType(keyToCopy)
  const keyOutInterpolationType = prop.keyOutInterpolationType(keyToCopy)
  const curKeyValue = prop.keyValue(keyToCopy)

  let keyTemporalAutoBezier, keyTemporalContinuous
  if (keyInInterpolationType === KeyframeInterpolationType.BEZIER && keyOutInterpolationType === KeyframeInterpolationType.BEZIER) {
    keyTemporalAutoBezier = prop.keyTemporalAutoBezier(keyToCopy)
    keyTemporalContinuous = prop.keyTemporalContinuous(keyToCopy)
  }

  let keyInTemporalEase, keyOutTemporalEase
  if (keyOutInterpolationType !== KeyframeInterpolationType.HOLD) {
    keyInTemporalEase = prop.keyInTemporalEase(keyToCopy)
    keyOutTemporalEase = prop.keyOutTemporalEase(keyToCopy)
  }

  let keySpatialAutoBezier, keySpatialContinuous, keyInSpatialTangent, keyOutSpatialTangent, keyRoving
  if (
    prop.propertyValueType === PropertyValueType.TwoD_SPATIAL ||
    prop.propertyValueType === PropertyValueType.ThreeD_SPATIAL
  ) {
    keySpatialAutoBezier = prop.keySpatialAutoBezier(keyToCopy)
    keySpatialContinuous = prop.keySpatialContinuous(keyToCopy)
    keyInSpatialTangent = prop.keyInSpatialTangent(keyToCopy)
    keyOutSpatialTangent = prop.keyOutSpatialTangent(keyToCopy)
    keyRoving = prop.keyRoving(keyToCopy)
  }

  return { keyInInterpolationType, keyOutInterpolationType, curKeyValue, keyTemporalAutoBezier, 
    keyTemporalContinuous, keyInTemporalEase, keyOutTemporalEase,
    keySpatialAutoBezier, keySpatialContinuous, keyInSpatialTangent, keyOutSpatialTangent, keyRoving }
}

export const setKeyValues = (prop, newKeyIndex, keyframe) => {
  prop.setValueAtKey(newKeyIndex, keyframe.curKeyValue)
  if (keyframe.keyOutInterpolationType !== KeyframeInterpolationType.HOLD)
    prop.setTemporalEaseAtKey(newKeyIndex, keyframe.keyInTemporalEase, keyframe.keyOutTemporalEase)
    prop.setInterpolationTypeAtKey(newKeyIndex, keyframe.keyInInterpolationType, keyframe.keyOutInterpolationType)

  if (
    keyframe.keyInInterpolationType === KeyframeInterpolationType.BEZIER &&
    keyframe.keyOutInterpolationType === KeyframeInterpolationType.BEZIER &&
    keyframe.keyTemporalContinuous
  ) {
    prop.setTemporalContinuousAtKey(newKeyIndex, keyframe.keyTemporalContinuous)
    prop.setTemporalAutoBezierAtKey(newKeyIndex, keyframe.keyTemporalAutoBezier)
  }

  if (
    prop.propertyValueType === PropertyValueType.TwoD_SPATIAL ||
    prop.propertyValueType === PropertyValueType.ThreeD_SPATIAL
  ) {
    prop.setSpatialContinuousAtKey(newKeyIndex, keyframe.keySpatialContinuous)
    prop.setSpatialAutoBezierAtKey(newKeyIndex, keyframe.keySpatialAutoBezier)
    prop.setSpatialTangentsAtKey(newKeyIndex, keyframe.keyInSpatialTangent, keyframe.keyOutSpatialTangent)
    if (keyframe.keyRoving) prop.setRovingAtKey(newKeyIndex, keyframe.keyRoving)
  }
}  
  
export const collectKeyframes = (propertyInput) => {
      if(propertyInput instanceof Property){
          var totalKeys, prop, keyIndexList, curKeyIndex, curKeyValue, inIn, outIn, ab, cb, ie, oe, sab, scb, ist, ost, rov, twoDS, threeDS;
          twoDS = PropertyValueType.TwoD_SPATIAL;
          threeDS = PropertyValueType.ThreeD_SPATIAL;
          keyIndexList = new Array();
          totalKeys = propertyInput.numKeys;
          
          //If the property has at least 1 keyframe, proceed
          if(totalKeys > 0){
              //Loop through keys
              for(var i = 1; i <= totalKeys; i++){
                  //Get the current key time...
                  curKeyTime = propertyInput.keyTime(i);
                  //...it's index...
                  curKeyIndex = i;
                  //...and it's value
                  curKeyValue = propertyInput.keyValue(i);
                  
                  //Get the key in and out interpolation types
                  inIn = propertyInput.keyInInterpolationType(curKeyIndex);
                  outIn = propertyInput.keyOutInterpolationType(curKeyIndex);
                  
                  //Get the key Temporal Continuous and Auto Bezier if the key type is BEZIER
                  if(inIn == KeyframeInterpolationType.BEZIER && outIn == KeyframeInterpolationType.BEZIER){
                      ab = propertyInput.keyTemporalAutoBezier(curKeyIndex);
                      cb = propertyInput.keyTemporalContinuous(curKeyIndex);
                  }
              
                  //Get it's Temporal ease if it is not a HOLD key type
                  if(inIn != KeyframeInterpolationType.HOLD || outIn != KeyframeInterpolationType.HOLD){
                      ie = propertyInput.keyInTemporalEase(curKeyIndex);
                      oe = propertyInput.keyOutTemporalEase(curKeyIndex);
                  }
              
                  //Get the key Spatial Continuous, Auto Bezier, Tangents, and Roving values if the key type is 2D or 3D SPATIAL
                  if(propertyInput.propertyValueType == twoDS || propertyInput.propertyValueType == threeDS){
                      sab = propertyInput.keySpatialAutoBezier(curKeyIndex);
                      scb = propertyInput.keySpatialContinuous(curKeyIndex);
                      ist = propertyInput.keyInSpatialTangent(curKeyIndex);
                      ost = propertyInput.keyOutSpatialTangent(curKeyIndex);
                      rov = propertyInput.keyRoving(curKeyIndex);
                  }
                  
                  //Assemble that collected key data into and object array for retrieval later
                  keyIndexList[keyIndexList.length] = {
                      'curKeyTime':curKeyTime, 
                      'curKeyIndex':curKeyIndex, 
                      'curKeyValue':curKeyValue, 
                      'keyInInterpolationType':inIn, 
                      'keyOutInterpolationType':outIn, 
                      'keyTemporalAutoBezier':ab, 
                      'keyTemporalContinuous':cb, 
                      'keyInTemporalEase':ie, 
                      'keyOutTemporalEase':oe, 
                      'keySpatialAutoBezier':sab, 
                      'keySpatialContinuous':scb, 
                      'keyInSpatialTangent':ist, 
                      'keyOutSpatialTangent':ost, 
                      'keyRoving':rov
                      }
              }
              //Return the object array as a result
              return keyIndexList;
          }else{
              //If there were no keyframes, then just return null as a result
              return null;
          }
      }
}



export const collectKeyframesInRange = (propertyInput, startIndex, endIndex) => {
  if(propertyInput instanceof Property){
      var totalKeys, prop, keyIndexList, curKeyIndex, curKeyValue, inIn, outIn, ab, cb, ie, oe, sab, scb, ist, ost, rov, twoDS, threeDS;
      twoDS = PropertyValueType.TwoD_SPATIAL;
      threeDS = PropertyValueType.ThreeD_SPATIAL;
      keyIndexList = new Array();
      totalKeys = propertyInput.numKeys;
      
      //If the property has at least 1 keyframe, proceed
      if(totalKeys > 0){
          //Loop through keys
          for(var i = startIndex; i <= endIndex; i++){
              //Get the current key time...
              curKeyTime = propertyInput.keyTime(i);
              //...it's index...
              curKeyIndex = i;
              //...and it's value
              curKeyValue = propertyInput.keyValue(i);
              
              //Get the key in and out interpolation types
              inIn = propertyInput.keyInInterpolationType(curKeyIndex);
              outIn = propertyInput.keyOutInterpolationType(curKeyIndex);
              
              //Get the key Temporal Continuous and Auto Bezier if the key type is BEZIER
              if(inIn == KeyframeInterpolationType.BEZIER && outIn == KeyframeInterpolationType.BEZIER){
                  ab = propertyInput.keyTemporalAutoBezier(curKeyIndex);
                  cb = propertyInput.keyTemporalContinuous(curKeyIndex);
              }
          
              //Get it's Temporal ease if it is not a HOLD key type
              if(inIn != KeyframeInterpolationType.HOLD || outIn != KeyframeInterpolationType.HOLD){
                  ie = propertyInput.keyInTemporalEase(curKeyIndex);
                  oe = propertyInput.keyOutTemporalEase(curKeyIndex);
              }
          
              //Get the key Spatial Continuous, Auto Bezier, Tangents, and Roving values if the key type is 2D or 3D SPATIAL
              if(propertyInput.propertyValueType == twoDS || propertyInput.propertyValueType == threeDS){
                  sab = propertyInput.keySpatialAutoBezier(curKeyIndex);
                  scb = propertyInput.keySpatialContinuous(curKeyIndex);
                  ist = propertyInput.keyInSpatialTangent(curKeyIndex);
                  ost = propertyInput.keyOutSpatialTangent(curKeyIndex);
                  rov = propertyInput.keyRoving(curKeyIndex);
              }
              
              //Assemble that collected key data into and object array for retrieval later
              keyIndexList[keyIndexList.length] = {
                  'curKeyTime':curKeyTime, 
                  'curKeyIndex':curKeyIndex, 
                  'curKeyValue':curKeyValue, 
                  'inIn':inIn, 
                  'outIn':outIn, 
                  'ab':ab, 
                  'cb':cb, 
                  'ie':ie, 
                  'oe':oe, 
                  'sab':sab, 
                  'scb':scb, 
                  'ist':ist, 
                  'ost':ost, 
                  'rov':rov
                  }
          }
          //Return the object array as a result
          return keyIndexList;
      }else{
          //If there were no keyframes, then just return null as a result
          return null;
      }
  }
}

export const shiftKeyToNewOffset = (prop, keyToCopy, offset, keyToRemove) => {
  if (offset === 0) return
  const value = getKeyValues(prop, keyToCopy)
  const newTime = prop.keyTime(keyToCopy) + offset
  const newKeyIndex = prop.addKey(newTime)
  setKeyValues(prop, newKeyIndex, value)
  prop.removeKey(keyToRemove)
}

const scootAllPropGroupKeys = (propGroup, offset) => {
  // Iterate over the specified property group's properties.
  for (let i = 1; i <= propGroup.numProperties; i++) {
    const prop = propGroup.property(i)
    if (prop.propertyType === PropertyType.PROPERTY) {
      if (prop.matchName === "ADBE Marker") continue
      if (!prop.isTimeVarying) continue

      if (offset > 0) {
        for (let j = prop.numKeys; j >= 1; j--)
          shiftKeyToNewOffset(prop, j, offset, j)
      } else {
        for (let j = 1; j <= prop.numKeys; j++)
          shiftKeyToNewOffset(prop, j, offset, j + 1)
      }
    } else if (prop.propertyType === PropertyType.INDEXED_GROUP) {
      scootAllPropGroupKeys(prop, offset)
    } else if (prop.propertyType === PropertyType.NAMED_GROUP) {
      scootAllPropGroupKeys(prop, offset)
    }
  }
}

const getNestedSelectedProperties = (propGroup) => {
  let props = []
  for (let i = 1; i <= propGroup.numProperties; i++) {
    const prop = propGroup.property(i)
    if (prop && prop.propertyType) {
      if (prop.propertyType === PropertyType.PROPERTY) {
        if (prop.matchName === 'ADBE Marker') continue
        if (!prop.isTimeVarying) continue
        if (!prop.selectedKeys || prop.selectedKeys.length <= 0) continue
        props.push(prop)
      } else if (prop.propertyType === PropertyType.INDEXED_GROUP && prop.property) {
        props = props.concat(getNestedSelectedProperties(prop))
      } else if (prop.propertyType === PropertyType.NAMED_GROUP && prop.property) {
        props = props.concat(getNestedSelectedProperties(prop))
      }
    }
  }

  return props
}

const getSelectedProperties = (comp) => {
  if (!PropertyType || !PropertyType.PROPERTY)
    throw new Error('PropertyType seems invalid. This may be because of another extension!')
  return (comp.selectedProperties || [])
    .filter(Boolean)
    .reduce((props, selectedProp) => {
      if (selectedProp.propertyType === PropertyType.PROPERTY) {
        if (
          selectedProp.matchName !== 'ADBE Marker' &&
          selectedProp.isTimeVarying &&
          selectedProp.selectedKeys && selectedProp.selectedKeys.length > 0
        ) {
          return [...props, selectedProp]
        }
      } else if (
        (selectedProp.propertyType === PropertyType.INDEXED_GROUP ||
        selectedProp.propertyType === PropertyType.NAMED_GROUP) &&
        selectedProp.numProperties
      ) {
        return props.concat(getNestedSelectedProperties(selectedProp))
      } else {
        return props
      }
    }, [])
}